import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

const UserList = ({ FilterUsers, GenerateQRCode, SelectedUsers }) => {
    return (
        <div>
            {FilterUsers.length > 0 && FilterUsers.map(users => (
                <div className="UserList" key={users._id} onClick={() => GenerateQRCode(users)}>{users.FirstName + " " + users.LastName}
                    {(SelectedUsers._id !== undefined && SelectedUsers._id === users._id) && (<span style={{ float: "right", color: "green" }}>
                        <FontAwesomeIcon icon={faCheck} />
                    </span>)}
                </div>
            ))}
        </div>
    );
};

export default UserList;